export const formatNumber = (
  number: number,
  config?: {
    locale?: Intl.LocalesArgument;
    options?: Intl.NumberFormatOptions;
  },
) => {
  return Intl.NumberFormat(config?.locale, config?.options).format(number);
};
